<template>
    <BaseContainer>
        <span slot="principal">
            <v-content class="pr-2 pl-2">
                <v-toolbar class="ma-2" style="border-radius: 30px;" dense>
                    <v-btn icon link to="/">
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>

                    <v-toolbar-title v-show="$vuetify.breakpoint.mdAndUp">
                        Clonagem de Cardápio
                    </v-toolbar-title>

                    <v-spacer/>

                    <v-tabs v-if="podeConsultar" v-model="aba" right show-arrows class="abas">
                        <v-tab>
                            <v-icon small left>mdi-database-arrow-right</v-icon>
                            Clonar
                        </v-tab>
                        <v-tab>
                            <v-icon small left>mdi-history</v-icon>
                            Histórico
                        </v-tab>
                    </v-tabs>
                </v-toolbar>

                <v-alert v-if="!podeConsultar" type="info" text class="ma-2">
                    Você não tem permissão para usar a clonagem de cardápio.
                </v-alert>

                <v-tabs-items v-else v-model="aba" touchless class="transparente">
                    <v-tab-item>
                        <TabClonagem v-if="podeExecutar" @concluido="recarregarHistorico"/>

                        <v-alert v-else type="info" text class="ma-2">
                            Você pode consultar o histórico, mas não executar clonagens.
                        </v-alert>
                    </v-tab-item>

                    <v-tab-item>
                        <TabHistorico ref="historico"/>
                    </v-tab-item>
                </v-tabs-items>
            </v-content>
        </span>
    </BaseContainer>
</template>

<script>
import BaseContainer from '@/components/BaseContainer';
import TabClonagem from './TabClonagem';
import TabHistorico from './TabHistorico';

export default {
    name: 'ClonagemCardapio',

    components: {
        BaseContainer,
        TabClonagem,
        TabHistorico,
    },

    data: () => ({
        aba: 0,
    }),

    computed: {
        podeConsultar() {
            return this.checkPermission('zapercontrol_clonagem_cardapio_consultar') || this.isDiretor();
        },

        podeExecutar() {
            return this.checkPermission('zapercontrol_clonagem_cardapio_executar') || this.isDiretor();
        },
    },

    methods: {
        recarregarHistorico() {
            const tab = this.$refs.historico;

            if (tab) tab.carregar(1);
        },
    },
};
</script>

<style scoped>
.abas {
    max-width: 320px;
}

.transparente >>> .v-window__container {
    background: transparent;
}
</style>
